import { ActionType } from '@elotech/components';
import { Dispatch } from 'react';

import * as UserService from '../../service/UserService';
import { AuthTypes } from '../../type';

export const getUserData = () => (dispatch: Dispatch<ActionType<object>>) => {
  return UserService.getUserData().then(response => {
    dispatch({ type: AuthTypes.GET_USERDATA, payload: response.data });
  });
};
